import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { VehiclesTypesService } from '../_services/vehicles-types.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-vehicles-types-list',
    templateUrl: './vehicles-types-list.component.html',
    styleUrls: ['./vehicles-types-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class VehiclesTypesListComponent implements OnInit {
  public vehiclesTypes: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private vehiclesTypesService: VehiclesTypesService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private loginService: LoginService
  ) {
    this.allowWrite = this.loginService.hasPermission("VEHICLE_TYPES.WRITE");
    this.allowDelete = this.loginService.hasPermission("VEHICLE_TYPES.DELETE");
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Tipos de vehículos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.vehiclesTypesService.all(params));
    this.vehiclesTypes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(vehicleType: any) {
    this.router.navigate(['vehiclesTypes/' + (vehicleType && Object.keys(vehicleType).length > 0 ? vehicleType.id : 0)]);
  }

  delete(vehicleType: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el tipo de vehículo "+vehicleType.name+"?",
        header: "Eliminar tipo de vehículo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.vehiclesTypesService.delete(vehicleType.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de vehículo eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
